import styled, { css } from 'styled-components';
import Icon from '../../../../components/Icon';

export const StatusContainer = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;

  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}

  & span {
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    text-align: center;
    color: white;
  }
`;

export const StatusWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledIcon = styled(Icon)`
  font-size: 18px;
  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;
